export const PLAYBOOK_PATH = '/resources/riders-foundation'
export const PLAYBOOK_ID = 'riders-foundation'
export const PLAYBOOK_CONSENT = 'Send me Scott’s horsemanship tips and offers by email. I can unsubscribe at any time.'

export interface PlaybookContent {
  id: string; title: string; introduction: string; closing: string
  sections: { id: string; title: string; summary: string; paragraphs: string[]; cues: string[]; tip: string }[]
}
export interface PlaybookResponse<T = PlaybookContent> { token?: string; playbook?: T }
const ACCESS_KEY = 'ah-playbook-reader'
export function accessToken(): string | null {
  try { const token = localStorage.getItem(ACCESS_KEY); if (token) return token } catch { /* Try session-only access. */ }
  try { return sessionStorage.getItem(ACCESS_KEY) } catch { return null }
}
export function saveAccess(token: string): void {
  try { localStorage.setItem(ACCESS_KEY, token) } catch {
    try { sessionStorage.setItem(ACCESS_KEY, token) } catch { /* Caller reports storage unavailable. */ }
  }
}
export function clearAccess(): void {
  try { localStorage.removeItem(ACCESS_KEY); sessionStorage.removeItem(ACCESS_KEY) } catch { /* Storage may be disabled. */ }
}
export async function playbookRequest<T = PlaybookContent>(action: 'unlock' | 'read' | 'complete', details: Record<string, unknown> = {}): Promise<PlaybookResponse<T>> {
  const token = accessToken()
  const response = await fetch('/api/playbookAccess', {
    method: 'POST', headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ action, playbookId: PLAYBOOK_ID, ...details }),
  })
  const data = await response.json().catch(() => null) as (PlaybookResponse<T> & { error?: string }) | null
  if (response.status === 401) clearAccess()
  if (!response.ok || !data) throw new Error(data?.error ?? 'Signup is temporarily unavailable. Please try again shortly.')
  return data
}
